import gql from 'graphql-tag';

export const queryForFacilitySignIns = gql`
  query queryForFacilitySignIns(
    $limit: Int
    $page: Int
    $query: FacilitySignInSortOrQuery
    $sort: FacilitySignInSortOrQuery
  ) {
    queryForFacilitySignIns(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        contactNumber
        facilityId
        company
        gaveConsent
        takenOrientation
        signInTime
        signOutTime
        Facility {
          id
          facilityName
          facilityUid
        }
        Area {
          id
          name
        }
      }
      totalRecords
    }
  }
`;
